import { z } from 'zod'
import { ItemTypeSchema } from './get.schema'

export const VarianceSearchParamsSchema = z.object({
  keyword: z.string().optional(),
  varianceType: z.coerce.number().pipe(ItemTypeSchema).optional(),
  zoneId: z.string().optional(),
  minVariancePercentage: z.number().optional(),
  maxVariancePercentage: z.number().optional(),
  status: z.enum(['PendingReview', 'Approved', 'Rejected']).optional(),
  lotNo: z.string().optional(),
  locationCode: z.string().optional(),
})

export type VarianceSearchParams = z.infer<typeof VarianceSearchParamsSchema>

export const VarianceItemSchema = z.object({
  id: z.string(),
  itemId: z.string(),
  lotNo: z.string().nullable(),
  lotDate: z.coerce.date().nullable(),
  locationCode: z.string(),
  systemQuantity: z.number().nullable(),
  actualQuantity: z.number().nullable(),
  variance: z.number(),
  variancePercentage: z.number(),
  varianceAmount: z.number(),
  varianceType: ItemTypeSchema,
  status: z.enum(['PendingReview', 'Approved', 'Rejected']),
  canApprove: z.boolean(),
})

export type VarianceItem = z.infer<typeof VarianceItemSchema>

export const VarianceSearchResultSchema = z.object({
  data: z.array(VarianceItemSchema),
})

export type VarianceSearchResult = z.infer<typeof VarianceSearchResultSchema>

export const ApproveVariancesRequestSchema = z.object({
  varianceIds: z.array(z.string()),
})

export type ApproveVariancesRequest = z.infer<
  typeof ApproveVariancesRequestSchema
>

export const RejectVariancesRequestSchema = z.object({
  varianceIds: z.array(z.string()),
  rejectionReason: z.string().min(1, 'กรุณาระบุเหตุผลในการปฏิเสธ'),
})

export type RejectVariancesRequest = z.infer<
  typeof RejectVariancesRequestSchema
>

export const RequestZoneRecountSchema = z.object({
  zoneIds: z.array(z.string()),
  reason: z.string().min(1, 'กรุณาระบุเหตุผลในการนับใหม่'),
})

export type RequestZoneRecountRequest = z.infer<typeof RequestZoneRecountSchema>
